module.exports = __webpack_public_path__ + "img/New PACI Flow - Enable Authentication - 2.f72c09bc.png";